import { Dispatch, ReactNode, SetStateAction } from 'react';
import { ModalState } from '../../models';
import { ModalContentWrapper, ModalTitleWrapper } from '../common/Modal';
import { CloseSVG } from '../styled/Close';
import { H3 } from '../styled/typography';
import { initialModalState } from '../../models/modal';

export function CommentsModalError({
  modal,
  close,
  setModalState,
}: {
  modal: {
    title: string;
    description: ReactNode;
  };
  close: () => void;
  setModalState: Dispatch<SetStateAction<ModalState>>;
}) {
  return (
    <ModalContentWrapper>
      <div css={{ padding: '18px 10px 10px 10px' }}>
        <ModalTitleWrapper
          setModalState={setModalState}
          customClose={
            <CloseSVG
              onClick={() => {
                setModalState(initialModalState);
                close();
              }}
              css={{ width: 25, height: 25 }}
            />
          }
        >
          <H3 css={{ fontSize: 18 }}>{modal.title}</H3>
        </ModalTitleWrapper>
      </div>
      <div css={{ padding: '0 40px 60px 40px' }}>{modal.description}</div>
    </ModalContentWrapper>
  );
}
